import { Link } from "react-router-dom";
import { useLang } from "@/i18n";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="relative overflow-hidden bg-[#F0F9FF] border-t border-[#DCEEF5] pt-16 pb-10" data-testid="main-footer">
      <span className="watermark absolute -bottom-8 left-1/2 -translate-x-1/2 text-[16vw] text-[#D9EEF8] whitespace-nowrap" aria-hidden="true">
        SELVAGGIO
      </span>
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col sm:flex-row justify-between gap-8">
          <div>
            <div className="flex items-center gap-3">
              <img src="/images/logo.png" alt="Logo Yuri Selvaggio" className="h-12 w-auto" />
              <div className="font-display font-extrabold text-lg text-[#0B2530]">YURI<span className="text-[#06B6D4]">·</span>SELVAGGIO</div>
            </div>
            <p className="text-sm text-[#5F7E8A] mt-3 max-w-xs leading-relaxed">
              {t.footer.text}
            </p>
          </div>
          <div className="flex gap-16">
            <div>
              <div className="font-mono-ed text-[11px] uppercase tracking-[0.18em] text-[#0284C7] mb-3">{t.footer.explore}</div>
              <div className="flex flex-col gap-2 text-sm text-[#3D5A66]">
                <Link to="/" className="hover:text-[#0284C7] transition-colors" data-testid="footer-link-home">Home</Link>
                <Link to="/galleria" className="hover:text-[#0284C7] transition-colors" data-testid="footer-link-galleria">{t.nav.galleria}</Link>
                <Link to="/titoli" className="hover:text-[#0284C7] transition-colors" data-testid="footer-link-attestati">{t.nav.attestati}</Link>
                <a href="/#contatti" className="hover:text-[#0284C7] transition-colors" data-testid="footer-link-contatti">{t.nav.contatti}</a>
                <Link to="/area-riservata" className="hover:text-[#0284C7] transition-colors" data-testid="footer-link-area-riservata">{t.nav.area}</Link>
              </div>
            </div>
            <div>
              <div className="font-mono-ed text-[11px] uppercase tracking-[0.18em] text-[#0284C7] mb-3">{t.footer.sedi}</div>
              <div className="text-sm text-[#3D5A66] leading-relaxed">
                Durazzo, Albania<br />Alessandria, Italia
              </div>
            </div>
          </div>
        </div>
        <div className="mt-14 pt-6 border-t border-[#CFE9F4] flex flex-col sm:flex-row justify-between gap-2 text-xs text-[#5F7E8A]">
          <span>{t.footer.rights}</span>
          <span className="font-serif-ed italic text-sm">{t.footer.quote}</span>
        </div>
      </div>
    </footer>
  );
};
